import styled from 'styled-components';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductChip } from '../../../../views/Product/listView/components/ProductChip';

SwiperCore.use([Autoplay, Pagination]);

export const ProductCategoryDescription = () => {
  return (
    <Container id={'carousel-swiper-container'}>
      <Swiper slidesPerView={1} loop pagination>
        <CustomSwiperSlide>
          <ContentsConatiner>
            <TitleSection>
              <ProductChip type={'PLUVA'} />
              <Title>{'플루바 매물이 뭔가요?'}</Title>
            </TitleSection>

            <Description>
              {'플루바 마켓이 직접 공수하고 점검을 거쳐\n할부, 탁송, 보증까지 제공하는 프리미엄 매물!'}
            </Description>
            <BackgroundImage
              xmlns={'http://www.w3.org/2000/svg'}
              width={'171'}
              height={'189'}
              viewBox={'0 0 171 189'}
              fill={'none'}
            >
              <path
                d={
                  'M323.57 27.7927C315.547 8.43456 277.927 8.27206 263.343 -6.33284C248.738 -20.9377 248.596 -58.5367 229.238 -66.5603C210.55 -74.3198 184.001 -48.1163 162.51 -48.1163C141.019 -48.1163 114.47 -74.3198 95.7826 -66.5806C76.4245 -58.557 76.262 -20.9377 61.6571 -6.35315C47.0522 8.25175 9.45322 8.39394 1.42966 27.752C-6.30951 46.4601 19.894 73.0089 19.894 94.4999C19.894 115.991 -6.30951 142.54 1.42966 161.227C9.45322 180.586 47.0725 180.748 61.6571 195.353C76.262 209.958 76.4042 247.557 95.7623 255.58C114.45 263.32 140.999 237.116 162.49 237.116C183.981 237.116 210.53 263.32 229.217 255.58C248.575 247.557 248.738 209.938 263.343 195.353C277.948 180.748 315.547 180.606 323.57 161.248C331.31 142.56 305.106 116.011 305.106 94.5202C305.106 73.0293 331.31 46.4804 323.57 27.7927ZM247.966 68.2354L166.715 149.487C162.754 153.448 157.554 155.438 152.354 155.438C147.154 155.438 141.954 153.448 137.993 149.487L87.2106 98.7046C79.2683 90.7623 79.2683 77.9246 87.2106 69.9823C95.1529 62.04 107.991 62.04 115.933 69.9823L152.354 106.403L219.244 39.5131C227.186 31.5708 240.024 31.5708 247.966 39.5131C255.908 47.4555 255.908 60.2931 247.966 68.2354Z'
                }
                fill={'#E4E4ED'}
              />
            </BackgroundImage>
          </ContentsConatiner>
        </CustomSwiperSlide>
      </Swiper>
    </Container>
  );
};

const Container = styled.section`
  width: 100%;
`;

const CustomSwiperSlide = styled(SwiperSlide)`
  z-index: 10;
  width: 100%;
  height: 189px;

  border-radius: 8px;
  cursor: pointer;
`;

const ContentsConatiner = styled.div`
  z-index: 99;
  display: flex;
  min-width: 390px;
  padding: 40px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  flex: 1 0 0;

  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const TitleSection = styled.div`
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;

const Description = styled.pre`
  z-index: 10;
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const BackgroundImage = styled.svg`
  z-index: 1;
  position: absolute;
  right: 0px;
  height: 189px;
`;
